let authService = (auth0Service, authStorageService, tokenHandlerService) => {
  const logout = () => {
    authStorageService.resetAll();

    return auth0Service.logout();
  };

  const forceLogin = () => {
    authStorageService.resetAll();

    return auth0Service.authorize();
  };

  const checkLoggedIn = () => {
    return auth0Service.checkSession()
      .then(tokenHandlerService.handleTokens)
      .catch(forceLogin);
  };

  const getAccessToken = () => authStorageService.getAccessToken();
  const getProfile = () => authStorageService.getProfile();
  const handleTokensHash = () => tokenHandlerService.handleTokensHash();

  return {
    logout,
    forceLogin,
    checkLoggedIn,
    getAccessToken,
    getProfile,
    handleTokensHash
  };
};

authService.$inject = [ 'auth0Service', 'authStorageService', 'tokenHandlerService' ];

export default authService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/auth.service.js